<app-layout>
  <div class="row">
    <div class="col-12">
      <div class="card p-0">
        <div class="card-header">
          <h3 class="card-title">Siparişler (Durumu: {{durumText}})</h3>
        </div>
        <div class="card-body border-bottom py-3">
          <div class="d-flex">
            <div class="mr-auto text-muted">
              Arama yap:
              <div class="ml-2 d-inline-block">
                <div class="input-icon mb-3">
                 <span class="input-icon-addon" style="left:auto;right:0;" *ngIf="siparisAraLoading">
                                <div class="spinner-border spinner-border-sm text-muted" role="status"></div>
                              </span>
                  <input name="kalemAra" [autocomplete]="true" type="text" class="form-control form-control-sm"
                         [(ngModel)]="siparisAraText" placeholder="Yazın ve Enter'a basın"
                         (keyup.enter)="siparisAraInputChange()">
                </div>
              </div>
            </div>
            <div class="text-muted">
              Gösterilen
              <div class="mx-2 d-inline-block">
                <select class="form-control form-control-sm" [(ngModel)]="showSearchResultCountSiparis"
                        (change)="siparisAraInputChange()">
                  <option *ngFor="let p of showSearchResultCountModelSiparis" [ngValue]="p">{{p}}</option>
                </select>
              </div>
              sonuç sayısı
            </div>
          </div>
        </div>
        <app-siparis-liste *ngIf="sourceSiparis" [source]="sourceSiparis.results"></app-siparis-liste>
        <div class="card-footer d-flex align-items-center" *ngIf="sourceSiparis">
          <p class="m-0 text-muted"><span>{{sourceSiparis.rowCount}}
            sonuçtan {{sourceSiparis.firstRowOnPage}}</span>-<span>{{sourceSiparis.lastRowOnPage}}</span> arası sonuçlar
          </p>
          <ul class="pagination m-0 ml-auto">
            <li class="page-item" [ngClass]="{'disabled':showSearchCurrentPageSiparis=== 1}">
              <div class="page-link" tabindex="-1" (click)="showPreviousPageSearchResultsSiparis()">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                     stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z"></path>
                  <polyline points="15 6 9 12 15 18"></polyline>
                </svg>
                önceki
              </div>
            </li>
            <li class="page-item" [ngClass]="{'disabled':showSearchCurrentPageSiparis === sourceSiparis.pageCount}">
              <div class="page-link" (click)="showNextPageSearchResultsSiparis()">
                sonraki
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                     stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z"></path>
                  <polyline points="9 6 15 12 9 18"></polyline>
                </svg>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="card p-0">
        <div class="card-header">
          <h3 class="card-title">İrsaliyeler</h3>
        </div>
        <div class="card-body border-bottom py-3">
          <div class="d-flex">
            <div class="mr-auto text-muted">
              Arama yap:
              <div class="ml-2 d-inline-block">
                <div class="input-icon mb-3">
                 <span class="input-icon-addon" style="left:auto;right:0;" *ngIf="irsaliyeAraLoading">
                                <div class="spinner-border spinner-border-sm text-muted" role="status"></div>
                              </span>
                  <input name="kalemAra" [autocomplete]="true" type="text" class="form-control form-control-sm"
                         [(ngModel)]="irsaliyeAraText" placeholder="Yazın ve Enter'a basın"
                         (keyup.enter)="irsaliyeAraInputChange()">
                </div>
              </div>
            </div>
            <div class="text-muted">
              Gösterilen
              <div class="mx-2 d-inline-block">
                <select class="form-control form-control-sm" [(ngModel)]="showSearchResultCountIrsaliye"
                        (change)="irsaliyeAraInputChange()">
                  <option *ngFor="let p of showSearchResultCountModelIrsaliye" [ngValue]="p">{{p}}</option>
                </select>
              </div>
              sonuç sayısı
            </div>
          </div>
        </div>
        <app-irsaliye-liste *ngIf="source" [source]="source.results"
                            (updateList)="getIrsaliyeler()"></app-irsaliye-liste>
        <div class="card-footer d-flex align-items-center" *ngIf="source">
          <p class="m-0 text-muted"><span>{{source.rowCount}}
            sonuçtan {{source.firstRowOnPage}}</span>-<span>{{source.lastRowOnPage}}</span> arası sonuçlar
          </p>
          <ul class="pagination m-0 ml-auto">
            <li class="page-item" [ngClass]="{'disabled':showSearchCurrentPageIrsaliye === 1}">
              <div class="page-link" tabindex="-1" (click)="showPreviousPageSearchResults()">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                     stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z"></path>
                  <polyline points="15 6 9 12 15 18"></polyline>
                </svg>
                önceki
              </div>
            </li>
            <li class="page-item" [ngClass]="{'disabled':showSearchCurrentPageIrsaliye === source.pageCount}">
              <div class="page-link" (click)="showNextPageSearchResults()">
                sonraki
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                     stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z"></path>
                  <polyline points="9 6 15 12 9 18"></polyline>
                </svg>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</app-layout>
